import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AddCompanyRoutingModule } from './add-company-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AddCompanyRoutingModule
  ]
})
export class AddCompanyModule { }
